/**
 * Korean translations
 */

export default {
  'Enter your email': '이메일 주소 입력',
  'Not included': '미포함',
  'Pause video': '비디오 일시정지',
  'Play video': '비디오 재생',
  'Pricing plans': '요금제',
  'Select an option': '옵션 선택',
  'Sign up for GitHub': 'GitHub 가입',
  Country: '국가',
  'The following fields have errors:': '다음 필드에 오류가 있습니다:',
  'You have the right to refuse the collection and use of your personal information, use of personal information or marketing purposes, and receiving marketing information as set forth above. However, if you refuse, you may not be able to receive the benefits described under Purpose of Collection & Use.':
    '귀하는 위에 명시된 개인정보 수집 및 이용, 마케팅 목적의 개인정보 이용, 마케팅 정보 수신을 거부할 권리가 있습니다. 단, 거부하실 경우 수집 및 이용 목적에 명시된 혜택을 받지 못할 수 있습니다.',
  'I agree to the collection and use of my personal information (required)*.':
    '개인 정보 수집 및 이용에 동의합니다(필수)*.',
  'Items of Personal Information to be Collected: {fields}, and any other fields visible on this form.':
    '수집되는 개인 정보: 성, 이름, 회사, 이메일 및 본 양식에 표시된 기타 작성란의 모든 항목.',
  'Purpose of Collection and Use: GitHub will use the data for the purpose described on this form.':
    '수집 및 이용 목적: GitHub에서는 본 양식에 설명된 목적으로 데이터를 사용합니다.',
  'Retention/Use Period of Personal Information: As long as needed to provide the service(s) you are requesting':
    '개인 정보 보유 기간/이용 기간: 귀하가 요청하는 서비스를 제공하는 데 필요한 기간',
  'I agree to receiving marketing information and use of my personal information for marketing purposes (optional).':
    '마케팅 정보 수신에 동의하며 마케팅 목적으로 본인의 개인 정보 사용에 동의합니다(선택 사항).',
  'Consent to Receive Marketing: The information collected may be used for GitHub for personalized communications, targeted advertising and campaign effectiveness.':
    '마케팅 수신 동의: 수집된 정보는 GitHub에서 개인 맞춤형 커뮤니케이션, 타겟형 광고, 캠페인 효과를 위해 사용될 수 있습니다.',
  'Purpose of Collection and Use: To contact you for marketing purposes.':
    '수집 및 이용 목적: 마케팅 목적으로 연락하기 위해.',
  'Retention/Use Period of Personal Information: As long as needed to provide the service(s) you are requesting.':
    '개인 정보 보유 기간/이용 기간: 귀하가 요청하는 서비스를 제공하는 데 필요한 기간.',
  'Yes please, I’d like GitHub and affiliates to use my information for personalized communications, targeted advertising and campaign effectiveness. See the':
    '네, GitHub 및 계열사가 개인 맞춤형 커뮤니케이션, 타겟 광고, 캠페인 효과를 위해 내 정보를 사용하는 것에 동의합니다. 자세한 내용은',
  'for more details.': '을 참조하세요.',
  'Participation requires transferring your personal data to other countries in which GitHub operates, including the United States. By submitting this form, you agree to the transfer of your data outside of China.':
    '참여하려면 미국을 포함하여 GitHub가 운영되는 다른 국가로 개인 데이터를 전송해야 합니다. 이 양식을 제출함으로써 귀하는 중국 외부로 데이터 전송에 동의합니다.',
  'I will receive personalized communications and targeted advertising from GitHub and affiliates. See the':
    '저는 GitHub 및 계열사로부터 개인 맞춤형 커뮤니케이션과 타겟 광고를 받게 됩니다. 자세한 내용은',
  'Yes, please, I’d like to hear from GitHub and its family of companies via email for personalized communications, targeted advertising, and campaign effectiveness. To withdraw consent or manage your contact preferences, visit the':
    '네, GitHub 및 계열사로부터 이메일을 통해 개인 맞춤형 커뮤니케이션, 타겟 광고, 캠페인 효과에 대한 정보를 받고 싶습니다. 동의를 철회하거나 연락처 환경설정을 관리하려면 다음을 방문하세요.',
  'Yes, please, I’d like to hear from GitHub and its family of companies via email and phone for personalized communications, targeted advertising, and campaign effectiveness. To withdraw consent or manage your contact preferences, visit the':
    '네, GitHub 및 계열사로부터 이메일과 전화로 개인 맞춤형 커뮤니케이션, 타겟 광고, 캠페인 효과에 대한 정보를 받고 싶습니다. 동의를 철회하거나 연락처 환경설정을 관리하려면 다음을 방문하세요.',
  'Promotional Communications Manager': '프로모션 커뮤니케이션 관리자',
  'GitHub Privacy Statement': 'GitHub 개인정보취급방침',
  'first name': '이름',
  'last name': '성',
  company: '회사',
  email: '이메일',
  'This field is required.': '이 필드는 필수입니다.',
  'Please enter a valid work email address.': '유효한 회사 이메일 주소를 입력하세요.',
  'The email is from a personal email provider.': '이메일이 개인 이메일 제공업체에 해당합니다.',
  'Please enter a valid email address.': '유효한 이메일 주소를 입력하세요.',
  'Please enter a valid phone number.': '유효한 전화번호를 입력하세요.',
  'Please select your country/region': '국가/지역을 선택하세요.',
  'Please complete the CAPTCHA.': 'CAPTCHA를 완료해 주세요.',
  'Choose your country/region': '국가/지역을 선택하세요.',
  Included: '포함',
  Refresh: '새로고침',
  Unlimited: '무제한',
  'Learn more': '자세히 알아보기',
  'Sort by:': '정렬 기준:',
  'Selecting a sort option will reload the page.': '정렬 옵션을 선택하면 페이지가 새로고침됩니다.',
  'Sort options': '정렬 옵션',
  Sort: '정렬',
  Newest: '최신순',
  Oldest: '오래된순',
  Whitepapers: '백서',
  Whitepaper: '백서',
  Ebooks: '전자책',
  Ebook: '전자책',
  AI: 'AI',
  Cloud: '클라우드',
  DevOps: 'DevOps',
  'GitHub Actions': 'GitHub Actions',
  'GitHub Advanced Security': 'GitHub Advanced Security',
  'GitHub Enterprise': 'GitHub Enterprise',
  Innersource: '이너 소스',
  'Open Source': '오픈 소스',
  Security: '보안',
  'Software Development': '소프트웨어 개발',
  'Explore other resources': '기타 리소스 살펴보기',
  Share: '공유',
  'Ebooks & Whitepapers': 'eBook 및 백서',
  Tags: '태그',
  Platform: '플랫폼',
  'AI CODE CREATION': 'AI 코드 생성',
  'GitHub Copilot': 'GitHub Copilot',
  'Write better code with AI': 'AI로 향상된 코드 작성',
  'GitHub Spark': 'GitHub Spark',
  'Build and deploy intelligent apps': '지능형 애플리케이션 구축 및 배포',
  'GitHub Models': 'GitHub Models',
  'Manage and compare prompts': '프롬프트 관리 및 비교',
  'MCP Registry (New)': 'MCP 레지스트리(신규)',
  'Integrate external tools': '외부 도구 통합',
  'View all features': '모든 기능 보기',
  'DEVELOPER WORKFLOWS': '개발자 워크플로',
  Actions: 'GitHub Actions',
  'Automate any workflow': '모든 워크플로 자동화',
  Codespaces: 'Codespaces',
  'Instant dev environments': '즉시 작업 가능한 개발 환경',
  Issues: 'GitHub Issues',
  'Plan and track work': '작업 계획 및 진행 상황 추적',
  'Code review': '코드 검토',
  'Manage code changes': '코드 변경 관리',
  'APPLICATION SECURITY': '애플리케이션 보안',
  'Find and fix vulnerabilities': '취약성 찾기 및 해결',
  'Code Security': 'Code Security',
  'Secure your code as you build': '구축 시 코드 보안',
  'Secret Protection': 'Secret Protection',
  'Stop leaks before they start': '기밀 유출 미리 예방',
  EXPLORE: '살펴보기',
  'Why GitHub': '왜 GitHub인가요',
  Documentation: '설명서',
  Blog: '블로그',
  Changelog: 'Changelog',
  'GitHub Marketplace': 'GitHub Marketplace',
  Solutions: '솔루션',
  'BY COMPANY SIZE': '회사 규모별',
  Enterprises: '엔터프라이즈',
  'Small and medium teams': '중소기업',
  Startups: '스타트업',
  Nonprofits: '비영리 단체',
  'View all solutions': '모든 솔루션 보기',
  'BY USE CASE': '사용 사례별',
  'App modernization': '앱 현대화',
  DevSecOps: 'DevSecOps',
  'View all use cases': '모든 사용 사례 보기',
  'BY INDUSTRY': '산업별',
  Healthcare: '의료 서비스',
  'Financial services': '금융 서비스',
  Manufacturing: '제조',
  Government: '정부 기관',
  'View all industries': '모든 산업군 보기',
  Resources: '리소스',
  'EXPLORE BY TOPIC': '주제별',
  'Software development': '소프트웨어 개발',
  'View all topics': '모든 주제 보기',
  'EXPLORE BY TYPE': '유형별 탐색',
  'Customer stories': '고객 스토리',
  'Events & webinars': '이벤트 및 웨비나',
  'Ebooks & reports': 'Ebook 및 보고서',
  'Business insights': '비즈니스 인사이트',
  'GitHub Skills': 'GitHub Skills',
  'SUPPORT & SERVICES': '지원 및 서비스',
  'Customer support': '고객 지원',
  'Community forum': '커뮤니티 포럼',
  'Trust Center': '신뢰 센터',
  Partners: '파트너',
  COMMUNITY: '커뮤니티',
  'GitHub Sponsors': 'GitHub Sponsors',
  'Fund open source developers': '오픈소스 개발자 지원',
  'The ReadME Project': 'ReadME 프로젝트',
  'GitHub community articles': 'GitHub 커뮤니티 기사',
  'COMMUNITY PROGRAMS': '커뮤니티 프로그램',
  'Security Lab': '보안 연구소',
  'Maintainer Community': '메인테이너 커뮤니티',
  Accelerator: '액셀러레이터',
  'Archive Program': '프로그램 아카이빙',
  REPOSITORIES: '리포지토리',
  Topics: '주제',
  Trending: '유행',
  Collections: '수집',
  Enterprise: '엔터프라이즈',
  'ENTERPRISE SOLUTIONS': '엔터프라이즈 솔루션',
  'Enterprise platform': '엔터프라이즈 플랫폼',
  'AI-powered developer platform': 'AI 기반 개발자 플랫폼',
  'AVAILABLE ADD-ONS': '추가로 제공되는 기능',
  'Enterprise-grade application security': '엔터프라이즈급 애플리케이션 보안',
  'Copilot for Business': 'Copilot Business',
  'Enterprise-grade AI features': '엔터프라이즈급 AI 기능',
  'Premium Support': '프리미엄 서포트',
  'Enterprise-grade 24/7 support': '엔터프라이즈급 상시 고객 지원',
  New: '신규',
  Select: '선택하기',
  'Install with script': '스크립트로 설치',
  'Install with npm': 'npm으로 설치',
  'Install with Homebrew': 'Homebrew로 설치',
  'Install with WinGet': 'WinGet으로 설치',
  Copy: '복사',
  'Copy installation command': '설치 명령어 복사',
  'Copied to clipboard': '클립보드에 복사',
  'Select install method': '설치 방법 선택',
  'Get Copilot CLI': 'Copilot CLI 사용하기',
  'Read the documentation.': '설명서 읽기.',
  'Included in Copilot Free, Pro, Pro+, Business, and Enterprise subscriptions.':
    'Copilot Free(무료), Pro, Pro+, 비즈니스, 엔터프라이즈 구독에 포함됨',
  'Included in Copilot Free, Pro, Pro+, Max, Business, and Enterprise subscriptions.':
    'Copilot Free(무료), Pro, Pro+, Max, 비즈니스, 엔터프라이즈 구독에 포함됨',
  'Available with Copilot Free, Pro, Pro+, Business, and Enterprise.':
    'Copilot Free(무료), Pro, Pro+, 비즈니스, 엔터프라이즈에서 사용할 수 있습니다.',
  'Available with Copilot Free, Pro, Pro+, Max, Business, and Enterprise.':
    'Copilot Free(무료), Pro, Pro+, Max, 비즈니스, 엔터프라이즈에서 사용할 수 있습니다.',
  'View all resources': '모든 리소스 보기',
  'Enterprise-grade security features': '엔터프라이즈급 보안 기능',
  Pricing: '가격',
  'Select country for phone number. Currently selected:': '전화번호의 국가를 선택하세요. 현재 선택됨:',
  'Search countries': '국가 검색',
  'Search countries...': '국가 검색...',
  Countries: '국가',
  'No countries found': '국가를 찾을 수 없음',
  '{count} result available': '{count}개의 결과 사용 가능',
  '{count} results available': '{count}개의 결과 사용 가능',
  'Get the ebook': 'ebook 받기',
  'Get the analysis': '분석 보고서 받기',

  // Marketing footer
  Subscribe: '구독',
  Ecosystem: '에코시스템',
  Support: '지원',
  Company: '회사',
  Features: '기능',
  Team: 'Team',
  Roadmap: '로드맵',
  'Compare GitHub': 'GitHub 비교',
  'Developer API': '개발자 API',
  Education: '교육',
  Docs: '문서',
  'Community Forum': '커뮤니티 포럼',
  'Professional Services': 'Professional Services',
  Skills: '기술',
  Status: '상태',
  'Contact GitHub': 'GitHub에 문의',
  About: '관련 정보',
  Careers: '커리어',
  Newsroom: '소식',
  Inclusion: '포용성',
  'Social Impact': '소셜 임팩트',
  Shop: '쇼핑',
  'What is Git?': 'Git이란 무엇인가요?',
  Sitemap: '사이트맵',
  Terms: '약관',
  Privacy: '개인 정보 보호',
  'Manage cookies': '쿠키 관리',
  'Do not share my personal information': '내 개인 정보 공유 금지',

  // Marketing footer — newsletter heading/description reuse legacy copy; "Customer Stories" reuses legacy "Customer stories" (pending loc review)
  'The developer newsletter': '개발자 뉴스레터 구독',
  'Get tips, technical guides, and best practices. Twice a month. Right in your inbox.':
    '팁, 기술 가이드, 모범 사례를 얻을 수 있습니다. 한 달에 두 번 제공됩니다.',
  'Customer Stories': '고객 사례',

  // Marketing footer — a11y/nav and social labels (drafted, pending loc verification)
  'Go to GitHub homepage': 'GitHub 홈페이지로 이동',
  'Site-wide Links': '사이트 전체 링크',
  'Legal and Resource Links': '법률 및 리소스 링크',
  "GitHub's Social Media Links": 'GitHub 소셜 미디어 링크',
  'Select language': '언어 선택',
  'GitHub on LinkedIn': 'LinkedIn의 GitHub',
  'GitHub on Instagram': 'Instagram의 GitHub',
  'GitHub on YouTube': 'YouTube의 GitHub',
  'GitHub on X': 'X의 GitHub',
  'GitHub on TikTok': 'TikTok의 GitHub',
  'GitHub on Twitch': 'Twitch의 GitHub',
  'GitHub’s organization on GitHub': 'GitHub의 GitHub 조직',
  // Add more translations here
}
